import {
  mutationOptions,
  useMutation,
  type UseMutationOptions,
} from '@tanstack/react-query';

import {
  type ValidateLabelingPayload,
  type ValidateLabelingResponse,
} from './types';
import { validateLabeling } from './validateLabeling';

export const getValidateLabelingMutationOptions = ({
  options,
}: {
  options?: Omit<UseMutationOptions, 'mutationFn'>;
}): UseMutationOptions => {
  return mutationOptions({
    mutationFn: async (queryParameters: ValidateLabelingPayload) =>
      validateLabeling(queryParameters),
    ...options,
  });
};

/**
 * Custom useMutation hook to validate labeling by counting unique field appearances per file and identifying missing fields.
 * @param options - Mutation options
 * @returns The validation result.
 * @see https://ai.vestigas.com/redoc#operation/labeling_validation_labeling_validation_get
 */
export const useMutationValidateLabeling = (
  options?: Omit<UseMutationOptions<ValidateLabelingResponse>, 'mutationFn'>,
) => {
  return useMutation({
    ...getValidateLabelingMutationOptions({
      options,
    }),
  });
};
